class GoogleInfoWindowController {
    constructor($scope) {
        this.infoWindow = new google.maps.InfoWindow(this.infoWindowOptions);

        this.infoWindow.addListener('closeclick', () => $scope.$apply(() => this.closeclick()));

        $scope.$watch(
            () => this.content,
            () => this.infoWindow.setContent(this.content),
        );

        $scope.$watchGroup(
            [() => this.isOpen, () => this.anchor],
            () => this.toggleInfoWindow(),
        );
    }

    toggleInfoWindow() {
        if (!this.isOpen) {
            this.infoWindow.close();
            return;
        }

        if (!this.map || !this.anchor) return;

        this.infoWindow.open(this.map, this.anchor);
    }

    closeclick() {
        this.isOpen = false;
        if (this.onCloseClick) {
            this.onCloseClick();
        }
    }

    setMap(map) {
        this.map = map;
    }
}

const googleInfoWindowDirectiveDefinition = () => ({
    restrict: 'E',
    require: ['olyGoogleInfoWindow', '^olyGoogleMap'],
    scope: {},
    bindToController: {
        infoWindow: '=?',
        infoWindowOptions: '=?',
        content: '=?',
        isOpen: '=',
        anchor: '=?',
        onCloseClick: '&?',
    },
    controller: ['$scope', GoogleInfoWindowController],
    controllerAs: 'googleInfoWindowCtrl',
    link(scope, element, attrs, controllers) {
        const infoWindowCtrl = controllers[0];
        const mapCtrl = controllers[1];

        infoWindowCtrl.setMap(mapCtrl.getMap());
    },
});

module.exports = {
    GoogleInfoWindowController,
    googleInfoWindowDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/googlemaps/google-info-window.directive.js